import salonPeterAudio from "../assets/images/icons/salon-peter-audio.svg";
import SalonActivityLayout from "../components/SalonActivityLayout";
import { useTranslation } from "../components/Localization";

export default function SalonPeterTaskPage() {
  const { t } = useTranslation();
  return <SalonActivityLayout taskKey="peter" step={0} progressIcon="bottom-right" backTo="/szalon" nextTo="/szalon/terites">
    <div className="salon-peter" aria-label={t("accessibility.peterAudio")}><img src={salonPeterAudio} alt={t("accessibility.peterAudio")} /></div>
  </SalonActivityLayout>;
}
